/**
 * paths.ts — the single place where a hook path meets the API base URL.
 *
 * Every hook calls `apiClient.get('/api/<resource>')`: the leading `/api` is a
 * logical marker meaning "the API root". The base URL (VITE_API_URL) already
 * IS the API root — `/api` in demo mode, `https://…/api/v1` in live mode — so
 * letting Axios join the two produced `/api/api/<resource>` in demo mode.
 *
 * `stripApiPrefix` removes the marker when a base URL is configured, so:
 *   demo  (base `/api`)                     → `/api/<resource>`
 *   live  (base `https://host/api/v1`)      → `https://host/api/v1/<resource>`
 *
 * With no base URL (unit tests that never load a .env file) the path is left
 * alone, so `/api/<resource>` is still requested same-origin.
 *
 * Copyright (c) 2026 PhiloFund. All rights reserved.
 */

const API_MARKER = '/api';

export function stripApiPrefix(url: string | undefined, baseURL: string | undefined): string | undefined {
  if (url === undefined || baseURL === undefined || baseURL === '') return url;
  if (url === API_MARKER) return '/';
  if (url.startsWith(`${API_MARKER}/`)) {
    return url.slice(API_MARKER.length);
  }
  return url;
}
